import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cc from 'classcat';
import { TYPE_DATE_PICKER } from 'utils/constants/sportsbook/results';
import { isMobile } from 'utils/is-mobile';
import { CompetitionFilter } from './__partials/CompetitionFilter';
import { DateFilter } from './__partials/DateFilter';
import { StatusFilter } from './__partials/StatusFilter';
import { TeamFilter } from './__partials/TeamFilter';
import { addQuery } from 'components/QueryRoute';
import { Button } from 'newcomponents/UI/Button';
import { setCurrentStatus, setTrigger } from 'store/actions/results-data';
import { getResultsData } from 'store/selectors/results-data';
import './index.less';

type Props = {
  vertical?: boolean;
  gameId?: string;
};

export const GeneralFilter: FC<Props> = ({
  vertical,
  gameId
}): ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const resultsData = useSelector(getResultsData);
  const history = useHistory();

  return (
    <div
      className={cc([
        'generalFilter__container',
        {
          'generalFilter__container--vertical': vertical
        }
      ])}
    >
      <div
        className={cc([
          'generalFilter__container__filters',
          {
            'generalFilter__container__filters--vertical': vertical,
            'generalFilter__container__filters--mobile':
              isMobile() && TYPE_DATE_PICKER
          }
        ])}
      >
        <DateFilter disabled={!resultsData} />
        <CompetitionFilter disabled={!resultsData} />
        {!vertical && <TeamFilter disabled={!resultsData} />}
        <StatusFilter disabled={!resultsData} />
      </div>
      <Button
        className="generalFilter__button"
        type="primary"
        size="large"
        disabled={!resultsData}
        onClick={e => {
          e.currentTarget.blur();
          gameId && history.push(addQuery({ game_id: undefined }));
          dispatch(setTrigger());
          setTimeout(() => dispatch(setCurrentStatus()));
        }}
        title={t('sportsbook.show')}
      >
        {t('sportsbook.show')}
      </Button>
    </div>
  );
};
